const STOREFRONT_BASE = (import.meta.env.VITE_STOREFRONT_URL || "http://localhost:3000").replace(/\/$/, "");

export function storefrontUrl(path: string): string {
  return `${STOREFRONT_BASE}${path.startsWith("/") ? path : `/${path}`}`;
}
